<template>
    <el-select
        :filter-method="onFilter"
        :name="name"
        :placeholder="placeholder"
        :value="value"
        :disabled="disabled"
        @change="$emit('change', $event)"
        @input="$emit('input', $event)"
        default-first-option
        filterable
    >
        <el-option
            :key="state.iso_3166_2"
            :label="$options.filters.uppercase(state.name)"
            :value="state.iso_3166_2"
            v-for="state in options"
        >
        </el-option>
    </el-select>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: ["placeholder", "value", "name", "disabled"],
    data() {
        return {
            filter: "",
        };
    },
    computed: {
        ...mapState({
            states: (state) => state.states.data,
        }),
        options() {
            return this.states.filter((state) =>
                state.name.toLowerCase().includes(this.filter.toLowerCase())
            );
        },
    },
    methods: {
        onFilter(e) {
            this.filter = e;
        },
    },
};
</script>

<style scoped></style>
